/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { LoVNode } from '../utils/types';
import { postAttendanceRecaptcha, getMember, getTier, getListOfValues } from '../services';
import { NoLoggedValuesData, solicitationTypeActions } from '../containers/CreateAttendance/NoLoggedForm/mock';
import { getMemberNumber, tabulationMapper, getTags } from '../utils';
import useAuth from './useAuth';
import { postMapper, postMapperPRD } from './types';

export function findMemberOccupation(userList: any, userData: any) {
  const occupationValue =
    userList?.occupation?.find((item: any) => userData?.member?.occupation === item.id && item)?.description || '';
  return { value: occupationValue };
}

type useSubmitProps = {
  list: LoVNode[];
  xRecaptcha: string;
};

export function useSubmitForm({ list, xRecaptcha }: useSubmitProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const { apiDomain } = useFlags();
  const { isLogged } = useAuth();
  const token = localStorage.getItem('session-token');

  function postMapperValidation() {
    const url: string = apiDomain;
    if (url.includes('-hml') || url.includes('-dev')) {
      return postMapper;
    }
    return postMapperPRD;
  }

  const onSubmit = async (data: NoLoggedValuesData) => {
    setIsLoading(true);
    const [userData, userTier, userList] = await Promise.all([
      getMember(apiDomain),
      getTier(apiDomain),
      getListOfValues(apiDomain),
    ]);

    function validateMemberNumber(memberNumber: string) {
      if (memberNumber) {
        return data.voebizCode;
      }
      if (isLogged) {
        return getMemberNumber(token);
      }
      return '';
    }

    try {
      const response = await postAttendanceRecaptcha({
        apiDomain,
        attendanceObj: {
          ticketInfo: {
            ticket: {
              subject: data.subject,
              description: data.solicitationType,
              comment: {
                body: `${data.message} \n ${!isLogged ? data.email : userData?.member.email}`,
                public: false,
              },
              ticket_form_id: 1900006384265,
              tags: [getTags(window.location.hostname)],
              author: {
                external_id: validateMemberNumber(data.voebizCode), // memberNumber pode ser que nao venha....
                name: isLogged
                  ? `${userData?.member.firstName} ${userData?.member.lastName}`
                  : `${data.firstName} ${data.lastName}`,
              },
              fields: [
                {
                  id: postMapperValidation().memberNumber, // memberNumber
                  value: validateMemberNumber(data.voebizCode),
                },
                { id: postMapperValidation().subChannel, value: 'formulario_site_voebiz' },
                {
                  id: postMapperValidation().phone1,
                  value: isLogged
                    ? `55${userData?.member.celPhoneDDDNumber1}${userData?.member.celPhoneNumber1}`
                    : `55${data.phoneNumber.replace(/[^0-9]+/gi, '')}`,
                },
                {
                  id: postMapperValidation().phone2,
                  value: isLogged
                    ? `55${userData?.member.homePhoneDDDNumber1}${userData?.member.homePhoneNumber1}`
                    : '',
                },
                {
                  id: postMapperValidation().CNPJ,
                  value: isLogged ? userData?.member.CNPJ : '',
                },
                {
                  id: postMapperValidation().CPF,
                  value: isLogged ? userData?.member.DOcumentNumber : '',
                },
                {
                  id: postMapperValidation().mainActivity,
                  value: isLogged
                    ? userList?.mainActivity.find((item) => userData?.member.mainActivity === item.id && item)
                        ?.description
                    : '',
                },
                {
                  id: postMapperValidation().numberOfEmployees,
                  value: isLogged ? userData?.member.numberOfEmployees : '',
                },
                {
                  id: postMapperValidation().annualBudgetforTravel,
                  value: isLogged ? userData?.member.annualBudgetforTravel : '',
                },
                {
                  id: postMapperValidation().occupation,
                  value: findMemberOccupation(userList, userData)?.value,
                },
                {
                  id: postMapperValidation().relationshipWithGol,
                  value: !isLogged ? data.relationshipWithGOL === 'Y' : false,
                },
                {
                  id: postMapperValidation().travelAgent,
                  value: data.travelAgent === 'Y',
                },
                {
                  id: postMapperValidation().userStatus,
                  value: isLogged ? userData?.member.status : '',
                },
                {
                  id: postMapperValidation().clientCategory,
                  value: isLogged ? getClientCategory(userData?.member.tier) : getClientCategory(data.clientCategory),
                },
                {
                  id: postMapperValidation().ticketChannel, // canal do ticket
                  value: 'voebiz',
                },
                {
                  id: postMapperValidation().ticketTabulation,
                  value: tabulationMapper(data, list)?.tab?.attributes.tabulacao_tag,
                },
                {
                  id: postMapperValidation().completeName,
                  value: !isLogged
                    ? `${data.firstName} ${data.lastName}`
                    : `${userData?.member.firstName} ${userData?.member.lastName}`,
                },
                {
                  id: postMapperValidation().email,
                  value: !isLogged ? data.email : userData?.member.email,
                },
                {
                  id: postMapperValidation().socialReason,
                  value: isLogged ? userData?.member?.socialReason : '',
                },
                {
                  id: postMapperValidation().fantasyName,
                  value: isLogged ? userData?.member?.fantasyName : '',
                },
                {
                  id: postMapperValidation().address,
                  value: isLogged
                    ? `${userData?.member.address.streetAddress}, número: ${userData?.member.address.streetAddressNumber}`
                    : '',
                },
                {
                  id: postMapperValidation().redeemablePoints,
                  value: isLogged ? userData?.member.milesBalance : '0',
                },
                {
                  id: postMapperValidation().qualifyingPoints,
                  value: isLogged ? userTier?.userInfo.upgradeInfo?.totalMilesClub : '0',
                },
                {
                  id: postMapperValidation().flightsCount,
                  value: '0',
                },
                {
                  id: postMapperValidation().reservationCode,
                  value: data.reservationCode,
                },
                {
                  id: postMapperValidation().HowYouMettheProgram,
                  value: isLogged ? userData?.member.HowYouMettheProgram : '',
                },
              ],
              attachments: data.attachments,
            },
          },
        },
        xRecaptcha,
      });
      if (response === 'Ticket created in Zendesk') {
        setSuccess(true);
        return response;
      }
      throw new Error('We have a problem to send this request');
    } catch (e: any) {
      console.error(e);
      setError(true);
      return e;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    success,
    onSubmit,
  };
}
function getClientCategory(clientCategory: string | undefined) {
  if (!clientCategory) {
    return '';
  }
  return solicitationTypeActions.find(({ name, id }) => (name === clientCategory ? id : ''))?.id;
}
